import _ from "lodash"

const incrementUnique = (unique: string, field: string, data: object[]): String => {
  const count = _.filter(data, i => _.startsWith(i[field], unique)).length
  return `${unique}-${count}`
}

export default incrementUnique
